(function () {
  var scrollScheduled = false;
  var scrollBound = false;
  var ctVideoScrollLockCount = 0;
  var ctVideoScrollY = 0;
  var ctVideoGlobalBound = false;

  function lockCtVideoScroll() {
    if (ctVideoScrollLockCount === 0) {
      ctVideoScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add("ct-video-modal-open");
      document.body.classList.add("ct-video-modal-open");
      document.body.style.top = "-" + ctVideoScrollY + "px";
    }
    ctVideoScrollLockCount += 1;
  }

  function unlockCtVideoScroll() {
    ctVideoScrollLockCount = Math.max(0, ctVideoScrollLockCount - 1);
    if (ctVideoScrollLockCount !== 0) return;
    document.documentElement.classList.remove("ct-video-modal-open");
    document.body.classList.remove("ct-video-modal-open");
    document.body.style.top = "";
    window.scrollTo(0, ctVideoScrollY);
  }

  function portalCtVideoModals(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    parent.querySelectorAll("[data-ct-video-modal]").forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function portalFigModals(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    parent.querySelectorAll("[data-fig-modal]").forEach(function (modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  function updateFigModalScrollState(modal) {
    if (!modal) return;
    var scrollEl = modal.querySelector("[data-fig-modal-scroll]");
    var closeBtn = modal.querySelector(".content-tabs__fig-modal-close");
    if (!scrollEl || !closeBtn) return;
    var shortContent = scrollEl.scrollHeight <= scrollEl.clientHeight + 4;
    var atBottom =
      shortContent || scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 8;
    modal.classList.toggle("is-scroll-end", atBottom);
    closeBtn.hidden = !atBottom;
    closeBtn.setAttribute("aria-hidden", atBottom ? "false" : "true");
    closeBtn.tabIndex = atBottom ? 0 : -1;
  }

  function openFigModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    lockCtVideoScroll();
    requestAnimationFrame(function () {
      modal.classList.add("is-open");
      var scrollEl = modal.querySelector("[data-fig-modal-scroll]");
      if (scrollEl) {
        scrollEl.scrollTop = 0;
      }
      updateFigModalScrollState(modal);
    });
  }

  function closeFigModal(modal) {
    if (!modal || modal.hidden) return;
    modal.classList.remove("is-open");
    window.setTimeout(function () {
      if (modal.classList.contains("is-open")) return;
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      unlockCtVideoScroll();
    }, 420);
  }

  function openCtVideoModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    lockCtVideoScroll();
    var video = modal.querySelector("video");
    if (video) {
      try {
        video.currentTime = 0;
        video.loop = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      } catch (err) {}
    }
  }

  function closeCtVideoModal(modal) {
    if (!modal) return;
    var video = modal.querySelector("video");
    if (video) {
      try {
        video.pause();
      } catch (err) {}
    }
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    unlockCtVideoScroll();
  }

  function ensureCtVideoGlobalHandlers() {
    if (ctVideoGlobalBound) return;
    ctVideoGlobalBound = true;

    document.addEventListener(
      "click",
      function (e) {
        var figOpenBtn = e.target.closest("[data-fig-modal-open]");
        if (figOpenBtn) {
          e.preventDefault();
          var figModalId = figOpenBtn.getAttribute("data-fig-modal-open");
          var figModal = figModalId ? document.getElementById(figModalId) : null;
          if (figModal) {
            openFigModal(figModal);
          }
          return;
        }

        var figCloseBtn = e.target.closest("[data-fig-modal-close]");
        if (figCloseBtn) {
          var figModalNode = figCloseBtn.closest("[data-fig-modal]");
          if (figModalNode) {
            e.preventDefault();
            closeFigModal(figModalNode);
          }
          return;
        }

        var closeBtn = e.target.closest("[data-ct-video-close]");
        if (!closeBtn) return;
        var modalNode = closeBtn.closest("[data-ct-video-modal]");
        if (modalNode) {
          e.preventDefault();
          closeCtVideoModal(modalNode);
        }
      },
      false
    );

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      document.querySelectorAll("[data-fig-modal]").forEach(function (modal) {
        if (modal.hidden) return;
        closeFigModal(modal);
      });
      document.querySelectorAll("[data-ct-video-modal]").forEach(function (modal) {
        if (modal.hidden) return;
        closeCtVideoModal(modal);
      });
    });
  }

  function bindFigModals(scope) {
    var parent = scope && scope.querySelectorAll ? scope : document;
    parent.querySelectorAll("[data-fig-modal]").forEach(function (modal) {
      if (modal.dataset.figModalBound === "true") return;
      modal.dataset.figModalBound = "true";

      modal.addEventListener("click", function (e) {
        if (modal.hidden || !modal.classList.contains("is-open")) return;
        if (e.target.closest(".content-tabs__fig-modal-sheet")) return;
        e.preventDefault();
        closeFigModal(modal);
      });

      var scrollEl = modal.querySelector("[data-fig-modal-scroll]");
      if (!scrollEl) return;
      scrollEl.addEventListener(
        "scroll",
        function () {
          updateFigModalScrollState(modal);
        },
        { passive: true }
      );
    });
  }

  function parsePx(val) {
    var n = parseFloat(val);
    return isNaN(n) ? 0 : n;
  }

  function getHeaderOffsetPx() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue("--header-height").trim();
    var px = 0;
    if (raw.indexOf("rem") !== -1) {
      px = parsePx(raw) * (parsePx(getComputedStyle(document.documentElement).fontSize) || 16);
    } else if (raw) {
      px = parsePx(raw);
    }
    if (px > 0) return px;
    var headerEl = document.querySelector(".section-header header") || document.querySelector(".section-header");
    if (headerEl) {
      var measured = Math.ceil(headerEl.getBoundingClientRect().height);
      if (measured > 0) return measured;
    }
    return 80;
  }

  function updateStickyNavHeight(root) {
    var stickyWrap = root.querySelector(".content-tabs__top-wrap--sticky");
    if (!stickyWrap) {
      root.style.removeProperty("--ct-sticky-nav-height");
      return;
    }
    root.style.setProperty(
      "--ct-sticky-nav-height",
      Math.ceil(stickyWrap.getBoundingClientRect().height) + "px"
    );
  }

  function isMobileStickyNav() {
    return window.matchMedia("(max-width: 749px)").matches;
  }

  function clearStickyNavFixedState(stickyWrap) {
    stickyWrap.classList.remove("content-tabs__top-wrap--is-fixed");
    stickyWrap.style.removeProperty("top");
    var spacer = stickyWrap.nextElementSibling;
    if (spacer && spacer.classList.contains("content-tabs__nav-spacer")) {
      spacer.remove();
    }
  }

  function updateStickyNavState(root) {
    var stickyWrap = root.querySelector(".content-tabs__top-wrap--sticky");
    if (!stickyWrap) return;

    if (isMobileStickyNav()) {
      clearStickyNavFixedState(stickyWrap);
      updateStickyNavHeight(root);
      return;
    }

    var navH = Math.ceil(stickyWrap.getBoundingClientRect().height);
    var main = root.querySelector(".content-tabs__main");
    var anchorTop = main ? main.getBoundingClientRect().top : root.getBoundingClientRect().top;
    var rootRect = root.getBoundingClientRect();
    var shouldFix = anchorTop <= 1 && rootRect.bottom > navH + 24;

    stickyWrap.classList.toggle("content-tabs__top-wrap--is-fixed", shouldFix);
    stickyWrap.style.removeProperty("top");

    var spacer = stickyWrap.nextElementSibling;
    if (
      shouldFix &&
      (!spacer || !spacer.classList.contains("content-tabs__nav-spacer"))
    ) {
      spacer = document.createElement("div");
      spacer.className = "content-tabs__nav-spacer";
      spacer.setAttribute("aria-hidden", "true");
      stickyWrap.insertAdjacentElement("afterend", spacer);
    }
    if (spacer && spacer.classList.contains("content-tabs__nav-spacer")) {
      spacer.style.height = shouldFix ? navH + "px" : "0";
      if (!shouldFix) {
        spacer.remove();
      }
    }

    updateStickyNavHeight(root);
  }

  function getActivationOffset(root) {
    var stickyWrap = root.querySelector(".content-tabs__top-wrap--sticky");
    var navH = 0;
    if (stickyWrap) {
      navH = stickyWrap.getBoundingClientRect().height;
    } else {
      var nav = root.querySelector(".content-tabs__top-wrap");
      if (nav) navH = nav.getBoundingClientRect().height;
    }
    return Math.round(navH + 8);
  }

  function updateRailVisibility(root) {
    var enabled = root.getAttribute("data-index-rail-enabled");
    if (enabled !== "true") return;

    var rail = root.querySelector("[data-content-tabs-rail]");
    if (!rail) return;

    var offset = getHeaderOffsetPx() + 4;
    var rect = root.getBoundingClientRect();

    // Show rail only while the section spans the header line:
    // - Before section reaches the header line: rail would appear "above" this section, so hide.
    // - After section leaves past the header line: hide.
    var inRange = rect.top <= offset && rect.bottom >= offset + 1;
    rail.classList.toggle("is-hidden", !inRange);
  }

  function syncRailTheme(root) {
    var rail = root.querySelector("[data-content-tabs-rail]");
    if (!rail) return;
    var activeRow = rail.querySelector(".content-tabs__rail-row.active");
    if (!activeRow) return;
    var panelBg = activeRow.getAttribute("data-rail-panel-bg");
    if (panelBg) {
      rail.style.setProperty("--ct-rail-panel-bg", panelBg);
    }
  }

  function setActive(root, activeId) {
    if (!activeId) return;

    root.querySelectorAll("[data-anchor-target]").forEach(function (el) {
      var id = el.getAttribute("data-anchor-target");
      var match = id === activeId;
      el.classList.toggle("active", match);
      if (
        el.classList.contains("content-tabs__menu-item") ||
        el.classList.contains("content-tabs__rail-row")
      ) {
        el.setAttribute("aria-current", match ? "true" : "false");
      }
    });
    syncRailTheme(root);
  }

  function computeActiveId(root, anchors) {
    if (!anchors.length) return null;

    var offset = getActivationOffset(root);
    var line = window.scrollY + offset;
    var activeId = anchors[0].id;

    for (var i = 0; i < anchors.length; i++) {
      var sec = anchors[i];
      var top = window.scrollY + sec.getBoundingClientRect().top;
      if (top <= line + 2) {
        activeId = sec.id;
      }
    }

    return activeId;
  }

  function tickScrollSpy() {
    document.querySelectorAll("[data-content-tabs-root]").forEach(function (root) {
      if (root.dataset.contentTabsAnchorBound !== "true") return;

      var anchors = Array.prototype.slice.call(root.querySelectorAll("[data-content-tabs-anchor]"));
      var id = computeActiveId(root, anchors);
      if (id) setActive(root, id);
      updateRailVisibility(root);
      updateStickyNavState(root);
    });
  }

  function scheduleSpy() {
    if (scrollScheduled) return;
    scrollScheduled = true;
    window.requestAnimationFrame(function () {
      scrollScheduled = false;
      tickScrollSpy();
    });
  }

  function ensureGlobalScroll() {
    if (scrollBound) return;
    scrollBound = true;

    window.addEventListener("scroll", scheduleSpy, { passive: true });
    window.addEventListener("resize", scheduleSpy);
  }

  function bindVideoTabPlayers(root) {
    root.querySelectorAll("[data-video-tab-player]").forEach(function (wrap) {
      if (wrap.dataset.vtpBound === "true") return;
      wrap.dataset.vtpBound = "true";

      var slides = Array.prototype.slice.call(wrap.querySelectorAll("[data-vtp-slide]"));
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll("[data-vtp-tab]"));
      var progressFill = wrap.querySelector("[data-vtp-progress-fill]");
      if (!slides.length) return;

      var slideCount = slides.length;
      var active = 0;
      var isPill = wrap.hasAttribute("data-pill-video-tabs");
      var viewport = wrap.querySelector("[data-pvt-viewport]");
      var track = wrap.querySelector("[data-pvt-track]");
      var prevBtn = isPill ? wrap.querySelector("[data-pvt-prev]") : null;
      var nextBtn = isPill ? wrap.querySelector("[data-pvt-next]") : null;
      if (isPill && (!viewport || !track)) {
        isPill = false;
        prevBtn = null;
        nextBtn = null;
      }

      function setProgress(t) {
        if (!progressFill) return;
        var p = typeof t === "number" && isFinite(t) ? t : 0;
        progressFill.style.width = Math.round(Math.max(0, Math.min(1, p)) * 10000) / 100 + "%";
      }

      function getVideo(i) {
        var s = slides[i];
        return s && s.querySelector ? s.querySelector("video") : null;
      }

      function onTimeUpdate(e) {
        var v = e.target;
        if (!v.duration || !isFinite(v.duration)) return;
        setProgress(v.currentTime / v.duration);
      }

      function onEnded() {
        if (isPill) {
          var cv = getVideo(active);
          if (!cv) return;
          try {
            cv.currentTime = 0;
          } catch (err) {}
          var replay = cv.play();
          if (replay && typeof replay.catch === "function") {
            replay.catch(function () {});
          }
          return;
        }
        goTo((active + 1) % slideCount);
      }

      var PVT_SLIDE_W = 804;
      var PVT_SLIDE_H = 358;
      var PVT_MOBILE_MQ = window.matchMedia("(max-width: 749px)");

      function isPvtMobile() {
        return PVT_MOBILE_MQ.matches;
      }

      function readPillSlideWidthPx() {
        if (isPvtMobile() && viewport) {
          return Math.max(240, Math.round(viewport.clientWidth * 0.87));
        }
        return PVT_SLIDE_W;
      }

      function readPillSlideHeightPx() {
        var w = readPillSlideWidthPx();
        return Math.round((w * PVT_SLIDE_H) / PVT_SLIDE_W);
      }

      function detachCurrent() {
        var v = getVideo(active);
        if (!v) return;
        v.removeEventListener("timeupdate", onTimeUpdate);
        v.removeEventListener("ended", onEnded);
        try {
          v.pause();
        } catch (err) {}
      }

      function pauseEveryVideo() {
        slides.forEach(function (slide) {
          var v = slide.querySelector("video");
          if (!v) return;
          v.removeEventListener("timeupdate", onTimeUpdate);
          v.removeEventListener("ended", onEnded);
          try {
            v.pause();
          } catch (err) {}
        });
      }

      function readTrackGapPx() {
        if (!track) return 14;
        var g = getComputedStyle(track).gap;
        var n = parseFloat(g);
        return isNaN(n) ? 14 : n;
      }

      function updatePillSlideWidths() {
        if (!isPill || !track) return;
        var slideW = readPillSlideWidthPx();
        var slideH = readPillSlideHeightPx();
        slides.forEach(function (el) {
          el.style.flex = "0 0 " + slideW + "px";
          el.style.width = slideW + "px";
          el.style.height = slideH + "px";
        });
        if (viewport) {
          viewport.style.height = slideH + "px";
        }
      }

      function updatePillTranslate() {
        if (!isPill || !viewport || !track || !slides.length) return;
        var V = viewport.clientWidth;
        var slideW = slides[0].offsetWidth || readPillSlideWidthPx();
        var gapPx = readTrackGapPx();
        var tx = V / 2 - slideW / 2 - active * (slideW + gapPx);
        track.style.transform = "translateX(" + tx + "px)";
      }

      function pillSyncTrack() {
        if (!isPill) return;
        updatePillSlideWidths();
        updatePillTranslate();
      }

      if (isPill && typeof ResizeObserver !== "undefined") {
        new ResizeObserver(function () {
          pillSyncTrack();
        }).observe(viewport);
      }

      if (isPill) {
        if (typeof PVT_MOBILE_MQ.addEventListener === "function") {
          PVT_MOBILE_MQ.addEventListener("change", function () {
            pillSyncTrack();
          });
        } else if (typeof PVT_MOBILE_MQ.addListener === "function") {
          PVT_MOBILE_MQ.addListener(function () {
            pillSyncTrack();
          });
        }
      }

      function updatePillNav() {
        if (!isPill) return;
        var atStart = active <= 0;
        var atEnd = active >= slideCount - 1;
        if (prevBtn) {
          if (atStart) prevBtn.setAttribute("hidden", "");
          else prevBtn.removeAttribute("hidden");
        }
        if (nextBtn) {
          if (atEnd) nextBtn.setAttribute("hidden", "");
          else nextBtn.removeAttribute("hidden");
        }
      }

      function syncUi() {
        slides.forEach(function (slide, i) {
          var on = i === active;
          slide.classList.toggle("is-active", on);
          slide.setAttribute("aria-hidden", on ? "false" : "true");
        });
        tabs.forEach(function (tab, i) {
          var on = i === active;
          tab.classList.toggle("is-active", on);
          tab.setAttribute("aria-selected", on ? "true" : "false");
        });
        if (isPill) {
          pillSyncTrack();
          updatePillNav();
        }
      }

      function goTo(nextIndex, opts) {
        opts = opts || {};
        var forceReplay = opts.forceReplay === true;
        if (slideCount === 0) return;

        var target = ((nextIndex % slideCount) + slideCount) % slideCount;

        if (target === active && !forceReplay) {
          return;
        }

        if (isPill) {
          pauseEveryVideo();
        } else {
          detachCurrent();
        }
        setProgress(0);

        active = target;
        syncUi();

        var nv = getVideo(active);
        if (!nv) return;
        nv.addEventListener("timeupdate", onTimeUpdate);
        nv.addEventListener("ended", onEnded);
        try {
          nv.currentTime = 0;
        } catch (err) {}
        var playPromise = nv.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }

      wrap.addEventListener(
        "click",
        function (e) {
          if (isPill && e.target.closest("[data-pvt-prev]") && active > 0) {
            goTo(active - 1);
            return;
          }
          if (isPill && e.target.closest("[data-pvt-next]") && active < slideCount - 1) {
            goTo(active + 1);
            return;
          }
          var tab = e.target.closest("[data-vtp-tab]");
          if (!tab || !wrap.contains(tab)) return;
          var idx = parseInt(tab.getAttribute("data-vtp-index"), 10);
          if (isNaN(idx)) return;
          var same = idx === active;
          goTo(idx, { forceReplay: same });
        },
        false
      );

      if (isPill && viewport) {
        var swipeStartX = 0;
        viewport.addEventListener(
          "touchstart",
          function (e) {
            if (!e.touches || !e.touches[0]) return;
            swipeStartX = e.touches[0].clientX;
          },
          { passive: true }
        );
        viewport.addEventListener(
          "touchend",
          function (e) {
            var t = e.changedTouches && e.changedTouches[0];
            if (!t) return;
            var dx = t.clientX - swipeStartX;
            if (dx > 52) goTo(active - 1);
            else if (dx < -52) goTo(active + 1);
          },
          { passive: true }
        );

        var ptrDownX = 0;
        viewport.addEventListener("pointerdown", function (e) {
          if (e.pointerType === "mouse" && e.button !== 0) return;
          ptrDownX = e.clientX;
          try {
            viewport.setPointerCapture(e.pointerId);
          } catch (err) {}
        });
        viewport.addEventListener("pointerup", function (e) {
          var dx = e.clientX - ptrDownX;
          try {
            if (viewport.hasPointerCapture(e.pointerId)) {
              viewport.releasePointerCapture(e.pointerId);
            }
          } catch (err2) {}
          if (Math.abs(dx) < 10) return;
          if (dx > 48) goTo(active - 1);
          else if (dx < -48) goTo(active + 1);
        });
      }

      goTo(0, { forceReplay: true });

      if (isPill) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            pillSyncTrack();
          });
        });
      }
    });
  }

  function bindVideoSidebarTabs(root) {
    root.querySelectorAll("[data-video-sidebar-tabs]").forEach(function (wrap) {
      if (wrap.dataset.vstBound === "true") return;
      wrap.dataset.vstBound = "true";

      var slides = Array.prototype.slice.call(wrap.querySelectorAll("[data-vst-slide]"));
      var accRows = Array.prototype.slice.call(wrap.querySelectorAll("[data-vst-acc]"));
      if (!slides.length) return;

      var count = slides.length;
      var active = 0;

      function getVideo(i) {
        var s = slides[i];
        return s && s.querySelector ? s.querySelector("video") : null;
      }

      function pauseAll() {
        slides.forEach(function (slide) {
          var v = slide.querySelector("video");
          if (!v) return;
          try {
            v.pause();
          } catch (err) {}
        });
      }

      function syncUi() {
        slides.forEach(function (slide, i) {
          var on = i === active;
          slide.classList.toggle("is-active", on);
          slide.setAttribute("aria-hidden", on ? "false" : "true");
        });
        accRows.forEach(function (row, i) {
          var on = i === active;
          row.classList.toggle("is-open", on);
          var btn = row.querySelector("[data-vst-tab]");
          if (btn) btn.setAttribute("aria-expanded", on ? "true" : "false");
        });
      }

      function goTo(nextIndex, opts) {
        opts = opts || {};
        var forceReplay = opts.forceReplay === true;
        if (count === 0) return;

        var target = ((nextIndex % count) + count) % count;

        if (target === active && !forceReplay) {
          return;
        }

        pauseAll();
        active = target;
        syncUi();

        var nv = getVideo(active);
        if (!nv) return;
        try {
          nv.currentTime = 0;
        } catch (err) {}
        var playPromise = nv.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(function () {});
        }
      }

      wrap.addEventListener(
        "click",
        function (e) {
          var btn = e.target.closest("[data-vst-tab]");
          if (!btn || !wrap.contains(btn)) return;
          var row = btn.closest("[data-vst-acc]");
          if (!row) return;
          var idx = parseInt(row.getAttribute("data-vst-index"), 10);
          if (isNaN(idx)) return;
          var same = idx === active;
          goTo(idx, { forceReplay: same });
        },
        false
      );

      goTo(0, { forceReplay: true });
    });
  }

  function bindOneCompareSlider(wrap) {
    if (!wrap || wrap.dataset.mtbCmpBound === "true") return;
    wrap.dataset.mtbCmpBound = "true";

    var range = wrap.querySelector("[data-mtb-compare-range]");
    var clip = wrap.querySelector("[data-mtb-compare-clip]");
    var handle = wrap.querySelector("[data-mtb-compare-handle]");
    var line = wrap.querySelector("[data-mtb-compare-line]");
    if (!range || !clip) return;

    function applyPct() {
      var n = parseFloat(String(range.value));
      if (isNaN(n)) n = 50;
      n = Math.max(0, Math.min(100, n));
      clip.style.clipPath = "inset(0 " + (100 - n) + "% 0 0)";
      if (handle) handle.style.left = n + "%";
      if (line) line.style.left = n + "%";
    }

    range.addEventListener("input", function () {
      applyPct();
    });
    range.addEventListener("change", function () {
      applyPct();
    });
    applyPct();
  }

  function bindMediaTabsShowcase(root) {
    root.querySelectorAll("[data-media-tabs-showcase]").forEach(function (wrap) {
      if (wrap.dataset.mtbBound === "true") return;
      wrap.dataset.mtbBound = "true";

      wrap.querySelectorAll("[data-mtb-compare]").forEach(function (cmp) {
        bindOneCompareSlider(cmp);
      });

      var tabs = Array.prototype.slice.call(wrap.querySelectorAll("[data-mtb-tab]"));
      var panels = Array.prototype.slice.call(wrap.querySelectorAll("[data-mtb-panel]"));
      var descs = Array.prototype.slice.call(wrap.querySelectorAll("[data-mtb-desc]"));
      if (!tabs.length) return;

      var active = 0;

      function pauseAllVideos() {
        wrap.querySelectorAll("video").forEach(function (v) {
          try {
            v.pause();
          } catch (err) {}
        });
      }

      function sync() {
        tabs.forEach(function (t, i) {
          var on = i === active;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        panels.forEach(function (p, i) {
          var on = i === active;
          p.classList.toggle("is-active", on);
          p.setAttribute("aria-hidden", on ? "false" : "true");
        });
        descs.forEach(function (d, i) {
          d.classList.toggle("is-active", i === active);
        });
      }

      function goTo(i) {
        if (i === active) return;
        pauseAllVideos();
        active = ((i % tabs.length) + tabs.length) % tabs.length;
        sync();
        var panel = panels[active];
        if (!panel) return;
        var v = panel.querySelector("video");
        if (v) {
          try {
            v.currentTime = 0;
          } catch (err) {}
          var playPromise = v.play();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(function () {});
          }
        }
      }

      wrap.addEventListener(
        "click",
        function (e) {
          var tab = e.target.closest("[data-mtb-tab]");
          if (!tab || !wrap.contains(tab)) return;
          var idx = parseInt(tab.getAttribute("data-mtb-index"), 10);
          if (isNaN(idx)) return;
          goTo(idx);
        },
        false
      );

      sync();
      var firstPanel = panels[0];
      if (firstPanel) {
        var fv = firstPanel.querySelector("video");
        if (fv) {
          try {
            fv.currentTime = 0;
          } catch (err) {}
          var p0 = fv.play();
          if (p0 && typeof p0.catch === "function") {
            p0.catch(function () {});
          }
        }
      }
    });
  }

  function bindRoot(root) {
    if (root.dataset.contentTabsAnchorBound === "true") return;
    root.dataset.contentTabsAnchorBound = "true";

    root.addEventListener(
      "click",
      function (e) {
        var openBtn = e.target.closest("[data-ct-video-open]");
        if (openBtn && root.contains(openBtn)) {
          e.preventDefault();
          var modalId = openBtn.getAttribute("data-ct-video-open");
          var modal = modalId ? document.getElementById(modalId) : null;
          if (modal) {
            openCtVideoModal(modal);
          }
          return;
        }

        var specBtn = e.target.closest("[data-spec-toggle]");
        if (specBtn && root.contains(specBtn)) {
          var specRoot = specBtn.closest("[data-spec-root]");
          if (specRoot) {
            var expanded = specRoot.getAttribute("data-spec-expanded") === "true";
            var next = !expanded;
            specRoot.setAttribute("data-spec-expanded", next ? "true" : "false");
            specBtn.setAttribute("aria-expanded", next ? "true" : "false");
            var moreL = specRoot.getAttribute("data-spec-label-more") || "View more";
            var lessL = specRoot.getAttribute("data-spec-label-less") || "View less";
            var labelEl = specBtn.querySelector(".content-tabs__spec-toggle-text");
            if (labelEl) {
              labelEl.textContent = next ? lessL : moreL;
            }
          }
          return;
        }

        var btn = e.target.closest("[data-anchor-target]");
        if (!btn || !root.contains(btn)) return;
        var id = btn.getAttribute("data-anchor-target");
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;

        if (btn.tagName === "A") {
          e.preventDefault();
        }

        var y = target.getBoundingClientRect().top + window.scrollY - getActivationOffset(root);
        window.scrollTo({ top: y, behavior: "smooth" });
        window.setTimeout(function () {
          setActive(root, id);
        }, 80);
      },
      false
    );

    portalCtVideoModals(root);
    portalFigModals(root);
    ensureCtVideoGlobalHandlers();
    bindFigModals(root);

    updateStickyNavState(root);
    ensureGlobalScroll();
    scheduleSpy();
    updateRailVisibility(root);
    syncRailTheme(root);
    bindVideoTabPlayers(root);
    bindVideoSidebarTabs(root);
    bindMediaTabsShowcase(root);
    bindStoriesCarousels(root);
    bindDpexCarousels(root);
    bindMobileFontAdjust(root);
  }

  var ctFontAdjustResizeBound = false;
  var ctFontAdjustScheduled = false;

  function collectMobileFontEntries(root) {
    var entries = [];
    root.querySelectorAll("[style]").forEach(function (el) {
      if (!root.contains(el)) return;
      if (!el.style.fontSize) return;
      entries.push({ el: el });
    });
    return entries;
  }

  function scheduleMobileFontAdjust() {
    if (ctFontAdjustScheduled) return;
    ctFontAdjustScheduled = true;
    window.requestAnimationFrame(function () {
      ctFontAdjustScheduled = false;
      document.querySelectorAll("[data-content-tabs-root]").forEach(function (root) {
        if (typeof root._ctFontApply === "function") root._ctFontApply();
      });
    });
  }

  function ensureMobileFontAdjustResize() {
    if (ctFontAdjustResizeBound) return;
    ctFontAdjustResizeBound = true;
    window.addEventListener("resize", scheduleMobileFontAdjust, { passive: true });
  }

  function bindMobileFontAdjust(root) {
    root._ctFontEntries = collectMobileFontEntries(root);

    root._ctFontApply = function () {
      var mobile = window.matchMedia("(max-width: 749px)").matches;
      root._ctFontEntries.forEach(function (entry) {
        var fontKey = "ctFsOrigFont";
        if (!entry.el.dataset[fontKey]) {
          entry.el.dataset[fontKey] = entry.el.style.fontSize;
        }
        var fontPx = parseFloat(entry.el.dataset[fontKey]);
        if (isNaN(fontPx)) return;
        entry.el.style.fontSize = (mobile ? Math.max(14, fontPx - 6) : fontPx) + "px";
      });
    };

    root._ctFontApply();
    ensureMobileFontAdjustResize();
  }

  function bindDpexCarousels(root) {
    root.querySelectorAll("[data-dpex-scroll]").forEach(function (scrollEl) {
      var track = scrollEl.querySelector("[data-dpex-track]");
      var dpexRoot = scrollEl.closest("[data-dpex-root]") || scrollEl.parentElement;
      var dotsWrap = dpexRoot && dpexRoot.querySelector("[data-dpex-dots]");
      if (!track) return;

      var cells = track.querySelectorAll(".content-tabs__dpex-cell");
      var dots = dotsWrap ? dotsWrap.querySelectorAll("[data-dpex-dot]") : [];

      function getActiveIndex() {
        if (!cells.length) return 0;
        var probe = scrollEl.scrollLeft + scrollEl.clientWidth * 0.35;
        var active = 0;
        for (var i = 0; i < cells.length; i++) {
          if (cells[i].offsetLeft <= probe + 1) active = i;
        }
        return active;
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle("is-active", on);
          dot.setAttribute("aria-selected", on ? "true" : "false");
        });
      }

      function scrollToIndex(index) {
        var cell = cells[index];
        if (!cell) return;
        scrollEl.scrollTo({ left: cell.offsetLeft, behavior: "smooth" });
      }

      var scrollRaf = 0;
      scrollEl.addEventListener(
        "scroll",
        function () {
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = 0;
            setActiveDot(getActiveIndex());
          });
        },
        { passive: true }
      );

      if (dotsWrap) {
        dotsWrap.addEventListener("click", function (e) {
          var dot = e.target.closest("[data-dpex-dot]");
          if (!dot) return;
          var index = parseInt(dot.getAttribute("data-dpex-index"), 10);
          if (isNaN(index)) return;
          scrollToIndex(index);
          setActiveDot(index);
        });
      }

      setActiveDot(0);
    });
  }

  function bindStoriesCarousels(root) {
    root.querySelectorAll("[data-stories-scroll]").forEach(function (scrollEl) {
      var track = scrollEl.querySelector("[data-stories-track]");
      var storiesRoot = scrollEl.closest("[data-stories-root]") || scrollEl.parentElement;
      var dotsWrap = storiesRoot && storiesRoot.querySelector("[data-stories-dots]");
      if (!track) return;

      var cards = track.querySelectorAll(".content-tabs__story-card");
      var dots = dotsWrap ? dotsWrap.querySelectorAll("[data-stories-dot]") : [];

      function getActiveIndex() {
        if (!cards.length) return 0;
        var probe = scrollEl.scrollLeft + scrollEl.clientWidth * 0.35;
        var active = 0;
        for (var i = 0; i < cards.length; i++) {
          if (cards[i].offsetLeft <= probe + 1) active = i;
        }
        return active;
      }

      function setActiveDot(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle("is-active", on);
          dot.setAttribute("aria-selected", on ? "true" : "false");
        });
      }

      function scrollToIndex(index) {
        var card = cards[index];
        if (!card) return;
        scrollEl.scrollTo({ left: card.offsetLeft, behavior: "smooth" });
      }

      var scrollRaf = 0;
      scrollEl.addEventListener(
        "scroll",
        function () {
          if (scrollRaf) return;
          scrollRaf = window.requestAnimationFrame(function () {
            scrollRaf = 0;
            setActiveDot(getActiveIndex());
          });
        },
        { passive: true }
      );

      if (dotsWrap) {
        dotsWrap.addEventListener("click", function (e) {
          var dot = e.target.closest("[data-stories-dot]");
          if (!dot) return;
          var index = parseInt(dot.getAttribute("data-stories-index"), 10);
          if (isNaN(index)) return;
          scrollToIndex(index);
          setActiveDot(index);
        });
      }

      setActiveDot(0);
    });
  }

  function initAll() {
    portalCtVideoModals(document);
    portalFigModals(document);
    ensureCtVideoGlobalHandlers();
    bindFigModals(document);
    document.querySelectorAll("[data-content-tabs-root]").forEach(bindRoot);
  }

  window.addEventListener(
    "resize",
    function () {
      document.querySelectorAll("[data-content-tabs-root]").forEach(function (root) {
        updateStickyNavState(root);
      });
    },
    { passive: true }
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    var root =
      target &&
      target.matches &&
      (target.matches("[data-content-tabs-root]")
        ? target
        : target.querySelector && target.querySelector("[data-content-tabs-root]"));
    if (!root) return;
    root.dataset.contentTabsAnchorBound = "false";
    bindRoot(root);
  });
})();
